import * as z from "zod/v4";

export const unarchiveAeoPrompts = {
  name: "unarchiveAeoPrompts" as const,
  input: z.object({ promptIds: z.array(z.string()).min(1).max(100) }),
  output: z.object({ success: z.boolean(), unarchivedCount: z.number() }),
};
